import { IssueStatusType } from '@kcftech/prometheustypescriptapiclient';
import { getIssueStatus } from 'pages/Desk/issues/shared';
import { memo } from 'react';
import { Lozenge } from 'shared/lozenge/Lozenge';

type StatusLozengeProps = Readonly<{
    id?: string;
    status: IssueStatusType;
}>;

function StatusLozenge({ id, status }: StatusLozengeProps) {
    const { label, textColor, backgroundColor } = getIssueStatus(status);

    const upperLabel = label.toUpperCase();

    return (
        <Lozenge id={id} color={textColor} backgroundColor={backgroundColor}>
            {upperLabel}
        </Lozenge>
    );
}

const memoStatusLozenge = memo(StatusLozenge);
export { memoStatusLozenge as StatusLozenge };
